import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Modal = ({ children, displayTitle = true, onCancel, open, title, width }) => {
  const { css } = useStyles();
  if(!width){
    width = '800px';
  }

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        paperScrollPaper: css({
          width: '100%',
          maxWidth: width,
          borderRadius: 20,
          position: 'relative',
          overflow: 'visible',
        }),
      }}
      onClose={onCancel}
      open={open}
    >
      <IconButton
        className={css({
          position: 'absolute',
          background: '#045ff9',
          color: 'white',
          top: -10,
          right: -10,
          '&:hover': {
            background: '#045ff9',
            color: 'white',
          },
        })}
        onClick={onCancel}
        size="small"
      >
        <Close fontSize="small" />
      </IconButton>
      {displayTitle && (
        <DialogTitle
          className={css({
            // background: '#0060F9',
            textAlign: 'center',
            color: 'white',
            fontWeight: 700,
            margin: 0,
            padding: 0,
          })}
          disableTypography
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

Modal.propTypes = {
  open: PropTypes.bool,
  displayTitle: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  onCancel: PropTypes.func,
};

export default Modal;
